// extracted by mini-css-extract-plugin
export default {"checkbox":"il_49B6r","checkboxLabel":"oIzooRAe","button":"UrWjZZx1"};